const themes = {
  palettes: {
    dark: {
      type: 'dark',
      primary: { main: '#fafafa' },
      secondary: { main: '#1F2125' },
      background: { default: '#141414' },
    },
    light: {
      type: 'light',
      primary: { main: '#1e2125' },
      secondary: { main: '#fff' },
      background: { default: '#fff' }
    },
    blue: {
      type: 'dark',
      primary: { main: '#b72c2c' },
      secondary: { main: '#0e232d' },
      background: { default: '#243c47' }
    }
  }
};

export default themes;
